var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5113 1.24382C17.9019 0.853298 18.535 0.853296 18.9256 1.24382L23.1682 5.48644C23.3557 5.67397 23.4611 5.92833 23.4611 6.19355C23.4611 6.45876 23.3557 6.71312 23.1682 6.90065L7.61186 22.457C7.42432 22.6445 7.16996 22.7499 6.90473 22.7499L2.66222 22.7498C2.10995 22.7498 1.66226 22.3021 1.66224 21.7498L1.66211 17.5073C1.6621 17.2421 1.76746 16.9877 1.955 16.8002L17.5113 1.24382ZM18.2185 3.36514L3.66212 17.9215L3.66221 20.7498L6.49055 20.7499L21.0469 6.19355L18.2185 3.36514Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2685 5.4865C13.659 5.09597 14.2922 5.09597 14.6827 5.4865L18.9253 9.72915C19.3159 10.1197 19.3159 10.7528 18.9253 11.1434C18.5348 11.5339 17.9017 11.5339 17.5111 11.1434L13.2685 6.90071C12.878 6.51019 12.878 5.87702 13.2685 5.4865Z",
    fill: "#141415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e2d734ccc96a6b8eac232d2eb9cbcc55.svg";
export { ForwardRef as ReactComponent };